import { render } from "./BaumAngabenStep.vue?vue&type=template&id=b2527936&scoped=true"
import script from "./BaumAngabenStep.vue?vue&type=script&lang=js"
export * from "./BaumAngabenStep.vue?vue&type=script&lang=js"

import "../form.css?vue&type=style&index=0&id=b2527936&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2527936"]])

export default __exports__